import autoBind from 'auto-bind'

import { ApiBase, RequestOptions } from 'api/core/ApiBase'
import { extractApiError } from 'api/errors/extractApiError'

export type AppPlatform = 'app' | 'dash' | 'pay'

export type AppApiBaseProps = {
  baseURL: string
  brand: string
  platform: AppPlatform
}

export class AppApiBase extends ApiBase {
  constructor({ baseURL, brand, platform }: AppApiBaseProps) {
    super({
      baseURL,
      withCredentials: true,
      headers: {
        'x-brand': brand,
        platform,
      },
    })
    autoBind(this)
  }

  async request<TData>(options: RequestOptions): Promise<TData> {
    return super.request<TData>(options).catch(async err => {
      throw await extractApiError(err)
    })
  }
}
